import { render, staticRenderFns } from "./BboxControl.vue?vue&type=template&id=27517070&"
import script from "./BboxControl.vue?vue&type=script&lang=js&"
export * from "./BboxControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports